import { FilterType, ListView, ListViewColumnType, initListView } from '../../UI/view/list-view';
import { customerChangedOrdersDS, ordersPermissions } from './orders-datasource';
import { OrderType, isDewarOnlyFilter, ordersListDebounce } from './orders-types';
import { getSourcePlantOptions } from '../../../services/requests/orders/orders-requests';

// Legacy gvCustomerChangedOrders ("Approved Orders Updated by Customers in CAS").
// Order Number	Customer Name	Px #	Date Requested	City	State	Location	Source Plant	Delivery Type	Order Type	Origin
export const customerChangedOrdersListView = {
  permissions: ordersPermissions,
  addButtonText: 'Create Order',
  addButtonPath: '/orders/create',
  filterGroup: 'orders',
  ...ordersListDebounce,
  filters: [
    {
      fieldName: 'orderTypeId',
      type: FilterType.multiselect,
      filterValue: { [1]: 1, [2]: 2, [3]: 3 },
      options: () => [1, 2, 3],
      labels: { 1: 'Gas', 2: 'Liquid', 3: 'Dewar' },
    },
    {
      fieldName: 'shippingLocationName',
      type: FilterType.combo,
      label: 'Source Plant',
      searchable: true,
      options: getSourcePlantOptions,
      serverExpression: 'ShippingLocation.LocationName == @val',
      valExpression: (val) => '"' + val + '"',
    },
  ],
  columns: [
    {
      Header: 'Order Number',
      accessor: 'orderNumber',
      type: ListViewColumnType.linkEdit,
      linkPath: ({ row }) => `/orders/edit/${row?.original?.id}`,
      excludeGlobalFilter: true,
    },
    {
      Header: 'Customer Name',
      accessor: 'customerName',
      excludeGlobalFilter: true,
      serverExpression:
        '(OrderTypeId == 1 ? GasCustomer.CustomerName : (OrderTypeId == 2 ? LiquidCustomer.CustomerName : (OrderTypeId == 3 ? DewarCustomer.AccountName : "")))',
    },
    { Header: 'Px #', accessor: 'customerId', excludeGlobalFilter: true },
    {
      Header: 'Date Requested',
      accessor: 'dateRequested',
      excludeGlobalFilter: true,
      type: ListViewColumnType.date,
      defaultSort: true,
      defaultSortDirection: 'asc',
    },
    { Header: 'City', accessor: 'city', excludeGlobalFilter: true },
    { Header: 'State', accessor: 'state', excludeGlobalFilter: true },
    {
      Header: 'Location',
      id: 'shippingCountry',
      excludeGlobalFilter: true,
      serverExpression: 'ShippingLocation.ResidentCountry',
      accessor: ({ shippingLocation }) => shippingLocation?.residentCountry || '',
    },
    {
      Header: 'Source Plant',
      id: 'shippingLocationName',
      excludeGlobalFilter: true,
      serverExpression: 'ShippingLocation.LocationName',
      accessor: ({ shippingLocation }) => shippingLocation?.locationName || '',
      filter: 'equals',
    },
    {
      Header: 'Delivery Type',
      id: 'deliveryType',
      excludeGlobalFilter: true,
      serverExpression: 'DeliveryType.Name',
      accessor: ({ deliveryType }) => deliveryType?.name || '',
    },
    {
      Header: 'Order Type',
      id: 'orderType',
      excludeGlobalFilter: true,
      serverExpression: 'OrderTypeId',
      accessor: ({ orderTypeId }) =>
        orderTypeId === OrderType.Gas
          ? 'Gas'
          : orderTypeId === OrderType.Liquid
          ? 'Liquid'
          : orderTypeId === OrderType.Dewar
          ? 'Dewar'
          : '',
    },
    { Header: 'Origin', id: 'origin', disableSortBy: true, excludeGlobalFilter: true, accessor: ({ orderOrigin }) => orderOrigin || '' },
    {
      Header: 'Manifest',
      id: 'manifest',
      disableSortBy: true,
      excludeGlobalFilter: true,
      show: (_viewOptions, filtersState) => isDewarOnlyFilter(filtersState),
      accessor: ({ dewarManifestLine }) => dewarManifestLine || '',
    },
    // Hidden, search-only columns: global search limited to id fields. Numeric
    // columns use .ToString() so the backend string(object(..)) wrapper doesn't
    // blow up casting an int to a string.
    { Header: 'Order # (search)', id: 'orderNumberSearch', accessor: 'orderNumber', serverExpression: 'OrderNumber.ToString()', hidden: true },
    { Header: 'Order Id (search)', id: 'orderIdSearch', accessor: 'orderId', hidden: true },
    { Header: 'Customer # (search)', id: 'customerIdSearch', accessor: 'customerId', serverExpression: 'CustomerId.ToString()', hidden: true },
    // Customer name is globally searchable via a COALESCE (not the ternary the
    // display column uses for sort) so it survives the backend string(object(..))
    // global-search wrapper.
    { Header: 'Customer Name (search)', id: 'customerNameSearch', accessor: 'customerName', serverExpression: 'GasCustomer.CustomerName ?? LiquidCustomer.CustomerName ?? DewarCustomer.AccountName', hidden: true },
    // Hidden, filter-only column backing the client-side Order Type filter.
    { Header: 'Order Type Id', id: 'orderTypeId', accessor: 'orderTypeId', hidden: true },
  ],
} as ListView;

export const CustomerChangedOrdersList = initListView(customerChangedOrdersListView, customerChangedOrdersDS);
